import React from "react";
import  { useState, useEffect } from 'react';
import './classes/RugbyAgency.css';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import AgencySidebar from "./AgencySidebar";

const RugbyAgency = () => {

    // const navigate = useNavigate();
    // const app_url = configData.APP_URL;
    const [isLoading, setIsLoading] = useState(true);
    const [rugbyDirectors, setrugbyDirectors] = useState([]);
    const [blogData, setBlogData] = useState([]);
    const app_url = configData.APP_URL;

    useEffect(() => {
         const rugbyDirectors = [             
            {
                name: "Jeff Murrells",
                image: "/basic/web/images/agent/picture-1598-1557869080.jpg",
                link: "/agent/jeff-murrells",
                bio: ["SMWW Rugby Director"]
            },
              {
                name: "Dr. Lynn Lashbrook",
                image: "/basic/web/images/agent/picture-2742-1696447573.jpg",
                link: "/agent/lynn-lashbrook",
                bio: ["SMWW Agency President & Founder"]
            },
             
        ];
        setrugbyDirectors(rugbyDirectors);
        
    },[]);

    useEffect(() => {
        Promise.all([
            getagencynewslist() 
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);

    // const handleClick = (continent) => {
    //     navigate('/continents/'+continent+'/scouts');
    // };
    async function getagencynewslist() {
        try {
            const response = await fetch(
                app_url+'smwwblog/getagencynewslist',
                {
                    method: "GET",
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setBlogData(responsedata.data.result);
            }
        } catch (error) {
            console.error(error);
        }finally {
            // Set loading to false after fetch completes (success or error)
        }
    }   
    
    return (
        <>
       {isLoading ? (
            <Loading />
        ) : ( 
            <div id="rugby-agency-banner-main">
            <div className="sports_agent_career_banner jobs_in_sports_banner" style={{"display":"inline-block","width":"100%"}}>
            <img className="medium_sized_image desktop-baseball-banner-img ban-img" src="/basic/web/images/agent/rugby_agency.png" style={{"width":"100%"}}/>
            <img className="medium_sized_image desktop-soccer-banner-img mobile_ban_img" src="/basic/web/images/agent/mobile_rugby.png" style={{"width":"100%"}}/>
          <div
            className="img_descp"
            style={{
                color: "white",
                position: "absolute",
                marginTop: "-21%",
                marginLeft: "27.5%",
                textShadow: "2px 2px 8px black, 0 0 25px black",
                filter: "drop-shadow(2px 2px 0px black)"
            }}
            >
            <h1
                className="h1_img_descp"
                style={{
                fontSize: "3.8vw",
                fontWeight: "bold"
                }}
            >
                SMWW Rugby Agency
            </h1>

            <h2
                className="h2_img_descp"
                style={{
                fontSize: "2.24vw"
                }}
            >
                An extensive network of Agent Advisors <br />
                 representing rugby players throughout <br/>
                  the world.
            </h2>
            </div>

            </div>
  
            <div id="main" className="rugby-agency-main">
                <Helmet><title>SMWW Rugby Agency</title></Helmet>
                <div className="left rugby-agency-left">
                    <div className="view-content">
                    <h2>Rugby Directors</h2>
                    <div className="item-list mentors-wrapper">
                    <ul>
                        {/* Desktop Wrapper */}
                        <div className="des_sports_wrapper">
                        {rugbyDirectors.map((director, index) => (
                            <li
                            key={index}
                            className={`views-row views-row-${index + 1} ${
                                index % 2 === 0 ? "views-row-odd" : "views-row-even"
                            } ${index === 0 ? "views-row-first" : ""} ${
                                index === rugbyDirectors.length - 1 ? "views-row-last" : ""
                            }`}
                            >
                            <div className="views-field views-field-picture">
                                <div className="field-content">
                                <img
                                    className="lazyloaded"
                                    width="193"
                                    height="158"
                                    src={director.image}
                                    alt={director.name}
                                />
                                </div>
                            </div>

                            <div className="views-field views-field-field-last-name">
                                <div className="field-content">
                                <a href={director.link}>{director.name}</a>
                                </div>
                            </div>

                            <div className="views-field views-field-field-mentor-biography text">
                                <div className="field-content">
                                <ul>
                                    {director.bio.map((item, i) => (
                                    <li key={i}>{item}</li>
                                    ))}
                                </ul>
                                </div>
                            </div>
                            </li>
                        ))}
                        </div>

                        {/* Mobile Wrapper */}
                        <div className="mob_sports_wrapper">
                        {rugbyDirectors.map((director, index) => (
                            <div
                            key={index}
                            className={index % 2 === 0 ? "mob_sports_wrapper_odd" : "mob_sports_wrapper_even"}
                            style={{ float: index % 2 === 0 ? "left" : "right", width: "49%" }}
                            >
                            <li
                                className={`sports_directors_li views-row views-row-${index + 1} ${
                                index % 2 === 0 ? "views-row-odd" : "views-row-even"
                                } ${index === 0 ? "views-row-first" : ""} ${
                                index === rugbyDirectors.length - 1 ? "views-row-last" : ""
                                }`}
                            >
                                <div className="views-field views-field-picture">
                                <div className="field-content">
                                    <img
                                    className="lazyloaded"
                                    width="193"
                                    height="158"
                                    src={director.image}
                                    alt={director.name}
                                    />
                                </div>
                                </div>

                                <div className="views-field views-field-field-last-name">
                                <div className="field-content">
                                    <a href={director.link}>{director.name}</a>
                                </div>
                                </div>

                                <div className="views-field views-field-field-mentor-biography text">
                                <div className="field-content">
                                    <ul>
                                    {director.bio.map((item, i) => (
                                        <li key={i}>{item}</li>
                                    ))}
                                    </ul>
                                </div>
                                </div>
                            </li>
                            </div>
                        ))}
                        </div>
                    </ul>
                    </div>

                </div>
                </div>
                <div className="center left-center">
                   <div className="rugby-agency-center">
                        <h1>SMWW Rugby Agency</h1>
                        <p>Sports Management Worldwide (SMWW) is one of the leading International Rugby&nbsp;agencies. The SMWW&nbsp;team has over 40 years of experience with contract negotiation, endorsements, sponsorship and athlete development, in all parts of the world. The SMWW Rugby Agency&nbsp;is headed up by <strong>RFU Registered&nbsp;Agent&nbsp;Jeff Murrells</strong>&nbsp;and supported by a Worldwide network of Agent Advisors. The&nbsp;knowledge &amp; experience of the team, with offices and agents in four&nbsp;hemispheres, combined with our global contacts, allow SMWW to be in a perfect position to represent the interests of elite professional rugby&nbsp;players.</p>
                        <p><strong>Typical services for our rugby&nbsp;clients include (but not limited):</strong><br/>
                        <em>All of our services are bespoke to meet the requirements of the client.</em></p>
                        <p>Playing and Commercial Contract Negotiation &amp; Re-negotiation<br/>
                        Commercial and Sponsorship Opportunites<br/>
                        Young professionals advice and support<br/>
                        Career advice – Playing &amp; Post Career<br/>
                        Club search, selection, and introduction - Globally<br/>
                        Player &amp; Family&nbsp;Liaison&nbsp;and General Support<br/>
                        Rugby Player Development<br/>
                        Professional&nbsp;preparation&nbsp;and support (physical and mental &nbsp;– on and off the pitch)</p>
                        <p>&nbsp;</p>
                        <p><strong>Our personal service means that we are always available to help you make the right decisions in your career.</strong></p>
                        <p>Personal Brand&nbsp;Management<br/>
                        Ongoing career advice and development assessments<br/>
                        Media Management &amp; Training<br/>
                        Wealth Management<br/>
                        Relocation Services<br/>
                        Lifestyle Management</p>
                        <p>We also have a strong and continually growing network with rugby clubs, rugby coaches, and rugby managers as well as SMWW Agent Advisors. This widens the rugby&nbsp;services we can offer to rugby players. If you are a professional rugby player who is looking for global opportunities and representation, we look forward to discussing your professional rugby career and the options available to you.</p>                      
                                               
                        <div style={{
                            listStyle: "none",
                            boxSizing: "border-box",
                            margin: 0,
                            padding: 0,
                            border: 0,
                            fontFamily: "sans-serif",
                            fontSize: "14px",
                            backgroundColor: "rgb(246, 245, 245)",
                            color: "rgb(255, 0, 0)"
                            }}>
                            <em style={{
                                listStyle: "none",
                                boxSizing: "border-box",
                                margin: 0,
                                padding: 0,
                                border: 0,
                                lineHeight: "18px"
                            }}>
                                If you are a rugby player looking for representation, we look forward to discussing your career and finding options available to you. Please complete our
                            </em>
                            <span style={{color: "rgb(0, 0, 0)"}}> </span>
                            <a href="/lookingforagent.php" style={{
                                listStyle: "none",
                                boxSizing: "border-box",
                                margin: 0,
                                padding: 0,
                                border: 0,
                                color: "rgb(33, 61, 134)",
                                fontSize: "14px",
                                fontFamily: "inherit",
                                fontStyle: "inherit",
                                backgroundColor: "rgb(246, 245, 245)",
                                outline: 0,
                                verticalAlign: "baseline"
                            }}>
                                online application
                            </a>
                            <span style={{color: "rgb(0, 0, 0)"}}>. </span>
                            </div>
                            <div className="p1" style={{"display": "flex","width": "50%","height":"210px"}}><img alt="" src="/basic/web/images/agent/rugby2_0.jpg" style={{"float": "left","objectFit": "contain"}}/>&nbsp; &nbsp; &nbsp;<img alt="" src="/basic/web/images/agent/rugby1(1)_0.jpg" style={{"objectFit": "contain"}}/></div>

                           <p>
                        <a
                            className="reddbtnn"
                            href="/agents/rugby"
                            style={{
                            width: '80%',
                            textAlign: 'center',
                            backgroundImage: 'linear-gradient(rgb(254, 0, 0) 0%, rgb(182, 0, 0) 100%)',
                            backgroundColor: 'rgb(255, 255, 255)',
                            }}
                        >
                            VIEW OUR RUGBY AGENTS
                        </a>
                        </p>

                    </div>
                </div>
                <div className="right agent-domain-sports">
                   <AgencySidebar/>
                   <h2>SMWW Sports Agency News</h2>
                   <div className="agency_blog">
                        <ul className="list-unstyled mb-0">
                            {blogData.slice(0, 5).map((post, index) => (
                            <div key={index}>
                                <li
                                style={{
                                    listStyleType: "none",
                                    listStyle: "outside none"
                                }}
                                >
                                <a href={post.link}>
                                    <img src={post.image} alt={post.title} />
                                </a>

                                <p className="stwwt-post-title">
                                    <a className="post-para" href={post.link}>
                                    {post.title}
                                    </a>
                                    <br />
                                    <a href={post.link}>
                                    <span className="button mr-1 arrow">Read Article</span>
                                    </a>
                                </p>
                                </li>

                                {/* Separator */}
                                {index < blogData.slice(0, 5).length - 1 && <li className="sepline">&nbsp;</li>}
                            </div>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
            </div>
        )}
        </>
    );
};
export default RugbyAgency;